import { render, staticRenderFns } from "./MultiMediaContent.vue?vue&type=template&id=3cc20b95&"
import script from "./MultiMediaContent.vue?vue&type=script&lang=js&"
export * from "./MultiMediaContent.vue?vue&type=script&lang=js&"
import style0 from "./MultiMediaContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports